module.exports = __webpack_public_path__ + "media/toy.412497cb.mp3";